const useBuildNewApplicationWizardPage = () => {
  const title = 'Build New Application Wizard';
  return {
    title,
  };
};
export default useBuildNewApplicationWizardPage;
